import React from 'react'
import Icon from '../../component/icon'
import './index.less'

export default ({ visible, onClear, children }) => {
  return <>
    {children}
    <Icon
      className="clearIcon"
      onClick={(e) => {
        e.stopPropagation()
        onClear(e)
      }}
      style={{
        marginLeft: '4px',
        fontSize: '16px',
      }}
      type="m-guanbi_tianchong"
    />
    <Icon
      type="m-Vxing_xia"
      className="dropIcon"
      style={{
        marginLeft: '4px',
        transform: visible ? 'rotate(180deg)' : undefined,
        transition: 'all 0.3s'
      }}
    />
  </>
}
